import React from "react";
import { Info } from "lucide-react";

export const mixedVersions = (versions) => new Set(versions.filter(Boolean)).size > 1;

export const ScoringVersionNote = ({ testId = "scoring-version-note" }) => (
  <p className="mt-2 inline-flex items-start gap-1.5 text-[12.5px] text-[#4b5563]" data-testid={testId}>
    <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
    Some results here were scored under different scoring versions, so small differences can come from the scoring update rather than the school.
  </p>
);
